import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form } from "react-bootstrap";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import moment from "moment";
import { withApollo } from "react-apollo";
import './_attendanceReport.scss';
import TableData from "./table_data";
import MultiSelect from "react-multi-select-component";
import ExcelContainer from './excelContainer.jsx';
import ReportDateBlock from './ReportDateBlock';

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};



class StudentAttendanceReportHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            BreadcrumbData: {
                Title: "Student Attendance",
                btnName: "Add Student"
            },
            currentStep: 1,
            loadingSpinner: 0,

            branch: "",
            branchSearch: "0",
            branchSearchval: "",
            branchError: "",


            exam: "",
            examSearch: "0",
            examSearchval: "",
            examError: "",
            getExamArr: [],




            section: "",
            sectionError: "",
            getSectionArr: [],
            sectionSelectedvalue: [],


            submitError: "",

            BranchesSection: {
                Title: "Students",
                btnName: "Add Student",
            },
            tableHeaderData: {
                Title: "Students",
            },

            branchSearch: "0",
            branchSearchval: "",
            examSearchval: "",

            class: "",
            classError: "",
            getClassArr: [],
            classSelectedvalue: [],


            getAttendanceReport: [],


            startDateCalender: moment(new Date()).subtract(1, "month").startOf('day').unix(),
            endDateCalender: moment(new Date()).startOf('day').unix(),
            attendance_types: [],
            attendanceData: [],
            submitted: false
        };
    }



    applyCallback = (startDate, endDate) => {


        this.setState({
            startDateCalender: startDate.unix(),
            endDateCalender: endDate.unix(),
            attendanceData: [],
            submitted: false
        })
    }


    handleMultipleSelectInputChange = async (e, name) => {

        if (name == "class") {

            let classSelectedvalue = [];

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const classval = e[i];
                    console.log("ddddddd", classval)
                    const newObj = {
                        label: classval.label,
                        value: classval.value,
                    }
                    classSelectedvalue.push(newObj);
                }
                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    attendanceData: [],
                    classError: "",
                    submitted: false

                });


                const delay = (ms) => new Promise((r) => setTimeout(r, ms));
                await delay(200);
                this.dropDownGetValues('sectionSearch', 0);
            }
        }


        if (name == "section") {

            let sectionSelectedvalue = [];

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const sectionval = e[i];
                    const newObj = {
                        label: sectionval.label,
                        value: sectionval.value,
                    }
                    sectionSelectedvalue.push(newObj);
                }
                this.setState({
                    sectionSelectedvalue: sectionSelectedvalue,
                    attendanceData: [],
                    sectionError: "",
                    submitted: false
                });
            }
        }
    }


    dropDownGetValues(fieldname, value) {
        let getArray = [];

        if (fieldname == "branchSearch" || fieldname == "examSearch") {

            const newObj1 = {
                value: "0",
                label: "Select"
            }
            getArray.push(newObj1);
        }

        if (fieldname == "branchSearch") {
            let uniqueBranches = [...new Set(this.props.globals.b_e_c_s_data.map((item) => item.branch_id))];
            uniqueBranches.map((val) => {
                let individualBranchData = this.props.globals.globalBranches.find((item1) => item1.id == val);
                const newObj = {
                    value: individualBranchData.id,
                    label: individualBranchData.branch_name
                }
                getArray.push(newObj);

            })
        } else if (fieldname == "examSearch") {

            let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

            uniqueExams.map((val) => {
                let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                const newObj = {
                    value: individualExamData.id,
                    label: individualExamData.exam
                }
                getArray.push(newObj);
            })

            this.setState({ getExamArr: getArray })

        } else if (fieldname == "classSearch") {

            let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == value).map((item1) => item1.class_id))].sort();

            uniqueClasses.map((val) => {
                let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                const newObj = {
                    value: individualClassData.id,
                    label: individualClassData.class
                }
                getArray.push(newObj);
            })

            this.setState({ getClassArr: getArray, classSelectedvalue: getArray })
        } else if (fieldname == "sectionSearch") {


            let sectionValues = this.state.classSelectedvalue.map((item) => item.value);

            console.log("selectedValue", sectionValues, this.state.branchSearch, this.state);


            let uniqueSections = []

            if (sectionValues.length > 0) {
                sectionValues.map((val) => {


                    let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == this.state.examSearch && item.class_id == parseInt(val)).map((item1) => item1.section_id))].sort();
                    console.log("individualsectionValues", individualsectionValues, val);
                    if (individualsectionValues.length > 0) {
                        individualsectionValues.map((item) => {
                            uniqueSections.push(item)
                        })
                    }
                })
                console.log("sectionValues", sectionValues, uniqueSections);

                uniqueSections.map((val) => {
                    let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualSectionData.id,
                        label: individualSectionData.section_name
                    }
                    getArray.push(newObj);
                })

                this.setState({ getSectionArr: getArray, sectionSelectedvalue: getArray })
            } else {
                this.setState({ getSectionArr: getArray, sectionSelectedvalue: getArray })
            }

        }
        return getArray;
    }

    selecthandleInputChange = async (ename, evalue) => {
        const name = ename;
        const value = evalue;
        //branch
        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globalBranches.find((a) => a.id == value);
                this.setState({
                    branchSearchval: {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    },
                    branch: branchSearchData.branch_name,
                    branchError: "",
                    attendanceData: [],
                    exam: "",
                    examSearch: "0",
                    examSearchval: "",
                    examError: "",
                    getExamArr: [],
                    attendance_types: [],
                    class: "",
                    classError: "",
                    getClassArr: [],
                    classSelectedvalue: [],
                    section: "",
                    sectionError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    submitted: false

                });
                this.dropDownGetValues('examSearch', value)
            } else {
                this.setState({
                    branchSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    branch: "",
                    attendanceData: [],
                    exam: "",
                    examSearch: "0",
                    examSearchval: "",
                    examError: "",
                    getExamArr: [],
                    attendance_types: [],
                    class: "",
                    classError: "",
                    getClassArr: [],
                    classSelectedvalue: [],
                    section: "",
                    sectionError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    submitted: false

                });
            }
        } else if (name == "examSearch") {
            if (value != "0") {
                let examSearchData = this.props.globals.exams.find((a) => a.id == value);
                this.setState({
                    examSearchval: {
                        value: examSearchData.id,
                        label: examSearchData.exam
                    },
                    exam: examSearchData.exam,
                    examError: "",
                    examSearch: examSearchData.id,
                    attendanceData: [],
                    attendance_types: [],
                    class: "",
                    classError: "",
                    getClassArr: [],
                    classSelectedvalue: [],
                    section: "",
                    sectionError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    submitted: false

                });
                this.getAttendanceTypes(value);
                this.dropDownGetValues('classSearch', value);

                const delay = (ms) => new Promise((r) => setTimeout(r, ms));
                await delay(200);

                this.dropDownGetValues('sectionSearch', value);

            } else {
                this.setState({
                    examSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    exam: "",
                    attendanceData: [],
                    examSearch: "0",
                    examSearchval: "",
                    examError: "",
                    attendance_types: [],
                    class: "",
                    classError: "",
                    getClassArr: [],
                    classSelectedvalue: [],
                    section: "",
                    sectionError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    submitted: false

                });
            }
        }

        //attendance Types
        this.setState({ [name]: value });
    }



    getAttendanceTypes = async (val) => {
        const result = await this.props.client.query({
            query: gql` 
           query($institution_id: Int,$exam_id:Int,$branch_id:Int
               ) {
                getAttendanceTypes(institution_id: $institution_id,exam_id:$exam_id,branch_id:$branch_id) {
                    id
                    attendance_subtype
                }
           }
       `,
            variables: {
                exam_id: parseInt(val),
                institution_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branchSearch),
            },
            fetchPolicy: 'network-only'
        });

        if (result.data.getAttendanceTypes != undefined) {
            let data = [];
            result.data.getAttendanceTypes.map((item) => {
                data.push({ value: item.id, label: item.attendance_subtype })
            })
            this.setState({
                attendance_types: data
            });
        }
    };



    handleFormSubmit = e => {


        if (this.state.branch == "") {
            this.setState({ branchError: "Please select branch" });
            return ""
        }


        if (this.state.exam == "") {
            this.setState({ examError: "Please select exam" });
            return ""
        }

        if (!this.state.classSelectedvalue.length) {
            this.setState({ classError: "Select class" });
            return ""
        }


        if (!this.state.sectionSelectedvalue.length) {
            this.setState({ sectionError: "Select section" });
            return ""
        }


        e.preventDefault();

        this.setState({
            loader: 1
        });



        this.getAttendanceData();
    };


    getAttendanceData = async () => {

        let sectionsArr = [];
        let classArr = [];

        for (let i = 0; i < this.state.sectionSelectedvalue.length; i++) {
            sectionsArr.push(parseInt(this.state.sectionSelectedvalue[i].value));
        }


        for (let i = 0; i < this.state.classSelectedvalue.length; i++) {
            classArr.push(parseInt(this.state.classSelectedvalue[i].value));
        }


        const result = await this.props.client.query({
            query: gql` 
           query(
            $institution_id: Int,$class_id:String,$section_id:String,$branch_id:String,$exam_id:String,$startTime:String,$endTime:String
               ) {
                getAttendanceData(institution_id: $institution_id,section_id:$section_id,branch_id:$branch_id,exam_id:$exam_id,class_id:$class_id,startTime:$startTime,endTime:$endTime) {
                    date
                    ces
                    section_id
                    class_id
                    sectionWiseStdCount
                    data {
                      present
                      absent
                      sick
                      attendance_subtype_id
                    }  
               }
           }
       `,
            variables: {
                exam_id: this.state.examSearch.toString(),
                institution_id: parseInt(Cookies.get("institutionid")),
                branch_id: this.state.branchSearchval.value.toString(),
                class_id: classArr.toString(),
                section_id: sectionsArr.toString(),
                startTime: this.state.startDateCalender.toString(),
                endTime: this.state.endDateCalender.toString()

            },
            fetchPolicy: 'network-only'
        });



        if (result.data.getAttendanceData != undefined) {
            let arr = [];
            result.data.getAttendanceData.map((item) => {
                arr.push({ date: item.date, ces: item.ces, data: item.data, section_id: item.section_id, class_id: item.class_id, sectionWiseStdCount: item.sectionWiseStdCount })
            })
            console.log("result.data.getAttendanceData", arr);

            this.setState({
                attendanceData: arr,
                loader: 0,
                submitted: true
            });
        }

    };



    render() {

        console.log("mahesh", this.state);

        let classselectall = true;
        let classlabelledBy = "Select";
        let classdisableSearch = false;

        let sectionselectall = true;
        let sectionlabelledBy = "Select";
        let sectiondisableSearch = false;



        if (this.props.globals.classes.length > 0) {
            classselectall = true;
            classdisableSearch = false;
        }
        else {
            classdisableSearch = true;
            classselectall = false;
            classlabelledBy = "Class"
        }



        if (this.props.globals.globalSections.length > 0) {
            sectionselectall = true;
            sectiondisableSearch = false;
        }
        else {
            sectiondisableSearch = true;
            sectionselectall = false;
            sectionlabelledBy = "Section"
        }




        return (
            <section className="attendance_report">
                <Container>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                                <h2 className="title h5 mb-0">Student Attendance Report</h2>

                                <div className="filter-block d-flex align-items-center mr-4">
                                    <Form.Group className="customDate mb-0 mr-4" controlId="StartDate" style={{ width: 180 }}>
                                        <ReportDateBlock applyCallback={this.applyCallback} start={this.start} end={this.end}
                                            stateData={this.props.stateData}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                        </Col>
                        <Col xl={12} lg={12} md={12} sm={12} className="studentTable">
                            <Row>
                                <Col lg={2} md={12} sm={12}>
                                    <h6>Branch </h6>
                                    <SelectDropDown
                                        stateData={this.state.branchSearchval}
                                        handleChange={this.selecthandleInputChange}
                                        name="branchSearch"
                                        options={this.dropDownGetValues("branchSearch")}
                                        placeholderName={'Branch'}
                                        dropdownIndicator={{ DropdownIndicator }}
                                    />
                                    <span className="text-danger f-16">{this.state.branchError}</span>
                                </Col>
                                <Col lg={2} md={12} sm={12}>
                                    <h6>Exam </h6>
                                    <SelectDropDown
                                        stateData={this.state.examSearchval}
                                        handleChange={this.selecthandleInputChange}
                                        name="examSearch"
                                        options={this.state.getExamArr}
                                        placeholderName={'Exam'}
                                        dropdownIndicator={{ DropdownIndicator }}
                                    />
                                    <span className="text-danger f-16">{this.state.examError}</span>
                                </Col>

                                <Col lg={2} md={12} sm={12}>
                                    <h6>Class </h6>
                                    <MultiSelect
                                        overrideStrings={{
                                            "allItemsAreSelected": "All Class are selected.",
                                            "selectSomeItems": classlabelledBy
                                        }
                                        }
                                        disableSearch={classdisableSearch}
                                        hasSelectAll={classselectall}
                                        options={this.state.getClassArr}
                                        value={this.state.classSelectedvalue}
                                        onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                        labelledBy={"class"}
                                    />
                                    <span
                                        className="text-danger f-16">{this.state.classError}</span>
                                </Col>
                                <Col lg={2} md={12} sm={12}>
                                    <h6>Section</h6>
                                    <MultiSelect
                                        overrideStrings={{
                                            "allItemsAreSelected": "All Sections are selected.",
                                            "selectSomeItems": sectionlabelledBy
                                        }
                                        }
                                        disableSearch={sectiondisableSearch}
                                        hasSelectAll={sectionselectall}
                                        options={this.state.getSectionArr}
                                        value={this.state.sectionSelectedvalue}
                                        onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                                        labelledBy={"section"}
                                    />
                                    <span className="text-danger f-16">{this.state.sectionError}</span>
                                </Col>

                                <Col lg={4} md={12} sm={12}>
                                    <Button variant="success" className="text-uppercase px-4 mt-4 ml-4 report_btn" onClick={this.handleFormSubmit}>Get Report</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    {
                        this.state.attendanceData.length > 0 ?
                            (
                                <>
                                    <Row className="mt-5">
                                        <Col sm={10}>
                                            <h6 className="main_line_heading">Attendance Results </h6>
                                        </Col>
                                        <Col sm={2}>
                                            <ExcelContainer stateData={this.state} attendanceTypes={this.state.attendance_types} />
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        <Col sm={12}>
                                            <TableData attendanceTypes={this.state.attendance_types} stateData={this.state} />
                                        </Col>
                                    </Row>
                                </>
                            )
                            :
                            (
                                <Container>
                                    <Row>
                                        <Col sm={12}>
                                            <div className={this.state.loader == 1 ?
                                                "spinner-border text-primary text-center loading-img-center mt-5" : ""} >
                                                {
                                                    this.state.submitted == true && this.state.loader == 0 && this.state.attendanceData.length == 0 ? (
                                                        <h6 className="d-flex justify-content-center align-items-center mt-5">No data available</h6>
                                                    ) : ("")
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            )
                    }



                </Container>
            </section>
        );
    }
}

export default withRouter(withApollo((StudentAttendanceReportHome)));


